import { StreamActions } from "@hotwired/turbo";

StreamActions.redirect = function () {
  Turbo.visit(this.target, { action: "replace" });
};

StreamActions.redirect_to = function () {
  Turbo.visit(this.target, { action: "advance" });
};

StreamActions.switch_modal = function () {
  const hideId = this.getAttribute("hide") || this.target;
  const showId = this.getAttribute("show");
  if (hideId) {
    const hideEl = document.getElementById(hideId);

    if (hideEl) {
      globalThis.bootstrap?.Modal.getInstance(hideEl)?.hide();
    }
  }

  if (showId) {
    const showEl = document.getElementById(showId);

    if (showEl) {
      globalThis.bootstrap?.Modal.getOrCreateInstance(showEl)?.show();
    }
  }
};

StreamActions.post_removed = function () {
  const groupElement = document
    .getElementById(this.target)
    ?.closest(".repost_list_frame");

  if (!groupElement) return;

  const items = groupElement.querySelectorAll(".item");

  if (items.length <= 2) {
    for (const item of items) {
      item.querySelector(".counter")?.remove();
      item.querySelector(".with-child")?.remove();
    }

    return;
  }

  for (const item of items) {
    const counter = item.querySelector(".counter");

    if (counter) {
      counter.dataset.total = items.length - 1;
    }
  }
};

StreamActions.update_followers_count = function () {
  const {
    user_id: userId,
    following,
    follower_count: followerCount,
    following_count: followingCount,
    current_user_following_count: currentUserFollowingCount,
    updated_at: updatedAt
  } = JSON.parse(this.target);

  updateFollowButton(userId, following);

  updateFollowCounts(
    userId,
    followerCount,
    followingCount,
    updatedAt
  );

  updateCurrentUserFollowingCount(currentUserFollowingCount);

  updateProfilePreviewFollowCounts(
    userId,
    followerCount,
    followingCount,
    updatedAt
  );
};

StreamActions.reload_turbo_frame = function () {
  const frameElement = document.getElementById(this.target);
  if (frameElement) frameElement.reload();
};

StreamActions.parent_append = function () {
  const target = document.querySelector(this.target)?.parentElement;

  if (!target) return;

  target.append(...this.templateElement.content.children);
};

function updateFollowButton(userId, following) {
  const frameElement = document.getElementById(`follow_unfollow_button_${userId}`);
  if (frameElement) {
    for (const element of frameElement.querySelectorAll("a")) {
      const isFollowing = String(following);

      if (element.dataset.isFollowing !== isFollowing) {
        element.dataset.isFollowing = isFollowing;
        element.classList.remove("disabled");
        element.dispatchEvent(new Event("disable-click:enable"));
      }
    }
  }

  const elements = Array.from(
    document.getElementsByClassName(`follow_unfollow_text_${userId}`)
  ).flatMap((element) => Array.from(element.querySelectorAll("a")));

  const isFollowing = String(following);

  for (const element of elements) {
    if (element.dataset.isFollowing !== isFollowing) {
      element.dataset.isFollowing = isFollowing;
      element.classList.remove("disabled");
      element.dispatchEvent(new Event("disable-click:enable"));
    }
  }
}

function updateFollowCounts(
  userId,
  followerCount,
  followingCount,
  updatedAt
) {
  for (const element of document.querySelectorAll(
    `.user_${userId}_followers`
  )) {
    updateCountIfNewer(element, followerCount, updatedAt);
  }

  for (const element of document.querySelectorAll(
    `.user_${userId}_following`
  )) {
    updateCountIfNewer(element, followingCount, updatedAt);
  }

  const profileFollowCount = document.querySelector(`#gapers_gaping_count_${userId}`);
  if (profileFollowCount) {
    profileFollowCount.querySelector(".followers-count").textContent = followerCount;
    profileFollowCount.querySelector(".followings-count").textContent = followingCount;
  }
}

function updateCurrentUserFollowingCount(count) {
  const element = document.getElementById("following_counts");

  if (element) {
    updateTextIfChanged(element, count);
  }
}

function updateProfilePreviewFollowCounts(
  userId,
  followerCount,
  followingCount,
  updatedAt
) {
  const entry = globalThis.__profilePreviewStore?.[userId];

  if (!entry?.node) return;

  const updatedAtValue = Number(updatedAt || 0);

  for (const element of entry.node.querySelectorAll(
    `.user_${userId}_followers`
  )) {
    updateTextIfChanged(element, followerCount);
    element.dataset.updatedAt = String(updatedAtValue);
  }

  for (const element of entry.node.querySelectorAll(
    `.user_${userId}_following`
  )) {
    updateTextIfChanged(element, followingCount);
    element.dataset.updatedAt = String(updatedAtValue);
  }

  entry.followerCount = followerCount;
  entry.followingCount = followingCount;
  entry.updatedAt = updatedAtValue;
}

function updateCountIfNewer(element, value, updatedAt) {
  const updatedAtValue = Number(updatedAt || 0);

  updateTextIfChanged(element, value);

  element.dataset.updatedAt = String(updatedAtValue);
}

function updateTextIfChanged(element, value) {
  const newValue = String(value);

  element.textContent = newValue;
}
